module.exports = __webpack_public_path__ + "media/images/badge/fedelissimo_secondary-fd3bb9745b3b98f2c46d6771e8cc2198.png";